import React, { useState, useEffect } from "react";
import {
  getCookieConsent,
  setCookieConsent,
  initYandexMetrika,
} from "../../utils/analytics";
import styles from "./CookieBanner.module.css";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    const consent = getCookieConsent();
    if (consent) {
      if (consent.analytics) initYandexMetrika();
    } else {
      setVisible(true);
    }
    window.openCookieSettings = () => setModalOpen(true);
    return () => {
      delete window.openCookieSettings;
    };
  }, []);

  const acceptAll = () => {
    setCookieConsent({ necessary: true, analytics: true, marketing: true });
    initYandexMetrika();
    setVisible(false);
  };

  const acceptNecessary = () => {
    setCookieConsent({ necessary: true, analytics: false, marketing: false });
    setVisible(false);
  };

  const saveSettings = () => {
    setCookieConsent({ necessary: true, analytics, marketing });
    if (analytics) initYandexMetrika();
    setModalOpen(false);
    setVisible(false);
  };

  return (
    <>
      {visible && (
        <div className={styles.banner}>
          <div className={styles.inner}>
            <p className={styles.text}>
              Мы используем cookie для работы сайта и анализа посещаемости.{" "}
              <a href="/cookie-policy" target="_blank" rel="noreferrer">
                Подробнее
              </a>
            </p>
            <div className={styles.buttons}>
              <button
                type="button"
                className={`${styles.btn} ${styles.primary}`}
                onClick={acceptAll}
              >
                Принять все
              </button>
              <button
                type="button"
                className={`${styles.btn} ${styles.secondary}`}
                onClick={acceptNecessary}
              >
                Только необходимые
              </button>
              <button
                type="button"
                className={`${styles.btn} ${styles.link}`}
                onClick={() => setModalOpen(true)}
              >
                Настроить
              </button>
            </div>
          </div>
        </div>
      )}

      {modalOpen && (
        <div
          className={styles.overlay}
          onClick={() => setModalOpen(false)}
          role="presentation"
        >
          <div
            className={styles.modal}
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="cookie-modal-title"
          >
            <h3 className={styles.modalTitle} id="cookie-modal-title">
              Настройки cookie
            </h3>

            <div className={styles.category}>
              <div className={styles.catRow}>
                <b>Строго необходимые</b>
                <span className={styles.badge}>Всегда активны</span>
              </div>
              <p>Обеспечивают корректную работу сайта.</p>
            </div>

            <div className={styles.category}>
              <div className={styles.catRow}>
                <b>Аналитические</b>
                <label className={styles.toggle}>
                  <input
                    type="checkbox"
                    checked={analytics}
                    onChange={(e) => setAnalytics(e.target.checked)}
                  />
                  <span className={styles.slider} />
                </label>
              </div>
              <p>
                Яндекс.Метрика (счётчик 61897962): анализ трафика и поведения.
              </p>
            </div>

            <div className={styles.category}>
              <div className={styles.catRow}>
                <b>Маркетинговые</b>
                <label className={styles.toggle}>
                  <input
                    type="checkbox"
                    checked={marketing}
                    onChange={(e) => setMarketing(e.target.checked)}
                  />
                  <span className={styles.slider} />
                </label>
              </div>
              <p>Ретаргетинг, рекламные системы.</p>
            </div>

            <div className={styles.footer}>
              <button
                type="button"
                className={`${styles.btn} ${styles.primary}`}
                onClick={saveSettings}
              >
                Сохранить настройки
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
